import { eriksFont } from './fontFace';
export var fontFamily = {
  primary: "".concat(eriksFont, ", Arial, sans-serif")
};
export var fontSize = {
  ft10: '	0.625rem',
  ft12: '0.75rem',
  ft14: '0.875rem',
  ft16: '1rem',
  ft20: '1.25rem',
  ft24: '1.5rem',
  ft32: '2rem',
  ft40: '2.5rem',
  ft72: '4.5rem'
};
export var fontWeight = {
  normal: '400',
  medium: '600'
};
export var lineHeight = {
  text: '1.4',
  heading: '1.4',
  base: '1'
};
export var letterSpacing = {
  text: '0',
  heading: '0'
};
export default {
  fontFamily: fontFamily,
  fontSize: fontSize,
  fontWeight: fontWeight,
  lineHeight: lineHeight,
  letterSpacing: letterSpacing
};